// Keeps a note range pointing at the same text while other edits land
// (remote collab inserts/deletes, Process edits) — used between clicking
// "Assign task" and the task being created, so the link lands on the text the
// user actually selected.
//
// Inserts exactly at the start push the range right; inserts exactly at the
// end stay outside it (the range never grows at its edges). Returns null when
// the selected text has been deleted entirely.
export function trackRange(range, delta) {
  if (!range || !delta || typeof delta.transformPosition !== "function") return range || null;
  const start = delta.transformPosition(range.index, false);
  const end = delta.transformPosition(range.index + range.length, true);
  const length = end - start;
  return length > 0 ? { index: start, length } : null;
}
